import type {ReactElement} from 'react';
import React from 'react';
import type {InviteStateProps} from '@Panels/share-panel/components/invite-state/invite-state.types';
import {InviteStateType} from '@Panels/share-panel/components/invite-state/invite-state.types';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';

export function InviteState({inviteesList = [], type = InviteStateType.SUCCESS, customText = undefined}: InviteStateProps): ReactElement<any> {
  const invitee = inviteesList[0] ? inviteesList[0] : '';

  const getTextValue = (): string => {
    if (customText) {
      return customText;
    }

    if (type === InviteStateType.ERROR) {
      return window.i18next.t('pmwjs_unable_to_sent_invite_x', {emailAddress: invitee});
    }
    if (inviteesList.length === 1) {
      return window.i18next.t('pmwjs_invite_sent_to_x', {emailAddress: invitee});
    } else {
      return window.i18next.t('pmwjs_invite_sent_to_x_and_count', {emailAddress: invitee, count: inviteesList.length - 1});
    }
  };

  return (
    <div className={`spacing-p-2 radius-8 ${type === InviteStateType.ERROR ? 'bg-danger-10' : 'bg-success-10'} flex-h-row flex-center spacing-m-t-3`}>
      <Icon
        icon={type === InviteStateType.ERROR ? 'icon-exclamation-triangle' : 'icon-check'}
        size={IconSize.SIZE_ICON_20}
        className={`${type === InviteStateType.ERROR ? 'content-danger' : 'content-success'} spacing-m-r-2`}
      />
      <Text val={getTextValue()} className={type === InviteStateType.ERROR ? 'content-danger' : 'content-success'} size={TextSize.XSMALL} dangerouslySetInnerHTML />
    </div>
  );
}
